// 📁 src/components/auth/SignInPage.jsx

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export default function SignInPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    const registry = JSON.parse(localStorage.getItem('accountRegistry') || '{}');
    const storedAccount = registry[email]; // ✅ now an object: { tenantId, password, companyName }

    console.log(`🔐 Attempting login for ${email}`);
    console.log(`🧪 Stored account:`, storedAccount);

    if (storedAccount && password === storedAccount.password) {
      sessionStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('email', email); // ✅ ensure email is stored for downstream sync

      // ✅ Hydrate tenantId and store it
      const tenantId = storedAccount.tenantId;
      if (tenantId) {
        localStorage.setItem('tenantId', tenantId);
        console.log('🏷️ Hydrated tenantId:', tenantId);
      }

      window.dispatchEvent(new Event('storage')); // ✅ Trigger Header update
      window.dispatchEvent(new Event('accountRegistryUpdated')); // ✅ Trigger TenantSoftwarePanel sync

      console.log('✅ Login successful');
      navigate('/cart');
    } else {
      setError('❌ Invalid credentials. Please try again.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="p-8 bg-white rounded shadow w-full max-w-md">
        <h2 className="text-3xl font-bold text-center mb-6">Sign In to Talentraxion</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full p-3 border rounded"
          />
          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full p-3 border rounded pr-10"
            />
            <span
              className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500 cursor-pointer"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-3 rounded hover:bg-blue-700"
          >
            Sign In
          </button>
          {error && <p className="text-red-600 text-sm text-center">{error}</p>}
        </form>

        <p className="text-sm text-center mt-4">
          Don’t have an account?{' '}
          <span
            className="text-blue-600 underline cursor-pointer"
            onClick={() => navigate('/register')}
          >
            Register
          </span>
        </p>

        <p className="text-sm text-center mt-2">
          <span
            className="text-blue-600 underline cursor-pointer"
            onClick={() => navigate('/reset-password')}
          >
            Forgot password? Reset here
          </span>
        </p>
      </div>
    </div>
  );
}
